import styled, { css } from 'styled-components';
import color from '@deprecated-ui/_style/color';
import PrimarySpinner from 'global/Loading/PrimarySpinner';

interface IContainerScreenerBodyProps {
  isFormActive?: boolean;
}

// prettier-ignore
const SContainerScreenerBody = styled.div`
  position: relative;
  display: block;
  width: 100%;
  padding: 20px;
  background: ${color.light};
  border-radius: 3px;
  border: 1px solid ${color.gainsboro};
  margin-bottom: 0px;
  border-top: 1px solid ${color.gainsboro};
  margin-top: 0px;
`;

// prettier-ignore
const SContainerScreenerPagination = styled.div < IContainerScreenerBodyProps >`
  position: relative;
  display: block;
  width: 100%;
  padding: 10px 20px;
  background: ${color.light};
  border-radius: 3px 3px 0 0;
  border: 1px solid ${color.gainsboro};
  margin-bottom: 0px;

  border-top: none;
  margin-top: 0px;

  ${({ isFormActive }) => isFormActive && css`
    border-top: 1px solid ${color.gainsboro};
    margin-top: 20px;
  `}
`;

const SContainerScreenerTable = styled.div`
  position: relative;
  display: block;
  background: ${color.light};
  border-right: 1px solid ${color.gainsboro};
  border-left: 1px solid ${color.gainsboro};
  border-bottom: 1px solid ${color.gainsboro};
  border-radius: 0 0 3px 3px;
`;

const SContainerScreener = styled.div`
  position: relative;
  padding-bottom: 45px;
`;

interface IContainerScreenerOverlayProps {
  isLoading: boolean;
}
const ScreenerLoadingOverlay = styled(PrimarySpinner).attrs({
  overlay: true,
})<IContainerScreenerOverlayProps>`
  display: none;
  &::before {
    border-top: 2px solid #ccc;
    border-right: 2px solid transparent;
  }

  ${({ isLoading }) =>
    isLoading &&
    css`
      display: block;
    `}
`;

const ScreenerResultEmpty = styled.div`
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${color.light};
  margin-top: 15px;
  border-radius: 3px;
`;

export {
  SContainerScreenerBody,
  SContainerScreenerTable,
  SContainerScreener,
  ScreenerLoadingOverlay,
  SContainerScreenerPagination,
  ScreenerResultEmpty,
};
